import React from 'react';
import { Layers, Info, Download } from 'lucide-react';
import Button from '../../../../../components/ui/Button';
import { formatCurrency } from '../../../../../utils/formatting';

/**
 * Компонент для отображения шкалы госпошлин
 */
const CourtFeeSchedule = ({ feeSchedule, results, showFullSchedule, setShowFullSchedule }) => {
  if (!feeSchedule || feeSchedule.length === 0 || !results) {
    return null;
  }

  // Форматирование границ диапазонов для отображения
  const formatRange = (min, max) => {
    if (min === 0 && max === 0) {
      return "Фиксированная ставка";
    }
    
    if (min === 0) {
      return `до ${formatCurrency(max)}`;
    }
    
    if (max === Infinity) {
      return `свыше ${formatCurrency(min)}`;
    }
    
    return `от ${formatCurrency(min)} до ${formatCurrency(max)}`;
  };

  // Определяем, в каком диапазоне находится сумма иска
  const currentRange = results.claimType === 'property' 
    ? feeSchedule.findIndex(item => 
        results.claimAmount >= item.min && 
        (item.max === Infinity || results.claimAmount <= item.max)
      )
    : 0;

  return (
    <div className="bg-white dark:bg-gray-800 rounded-xl border border-gray-200 dark:border-gray-700 shadow-sm p-5 mt-8">
      <div className="flex items-center justify-between mb-4 flex-wrap gap-2">
        <h3 className="text-lg font-medium text-gray-900 dark:text-white flex items-center">
          <Layers className="w-5 h-5 mr-2 text-indigo-500" />
          Шкала госпошлин
        </h3>
      </div>

      {/* Информационная подсказка */}
      <div className="bg-blue-50 dark:bg-blue-900/20 border border-blue-100 dark:border-blue-800 rounded p-3 mb-4 flex items-start">
        <Info className="text-blue-500 dark:text-blue-400 w-5 h-5 mr-2 flex-shrink-0 mt-0.5" />
        <div className="text-sm text-blue-700 dark:text-blue-300">
          <p>Ниже представлена шкала госпошлин в соответствии с выбранным типом суда и характером требований. 
          Выделенная строка соответствует вашей сумме иска.</p>
        </div>
      </div>

      {/* Контейнер таблицы с прокруткой */}
      <div className="overflow-x-auto rounded-lg border border-gray-200 dark:border-gray-700 fee-schedule-table">
        <table className="w-full text-sm text-left text-gray-700 dark:text-gray-300">
          <thead className="text-xs text-gray-700 dark:text-gray-300 uppercase bg-gray-100 dark:bg-gray-700 sticky top-0 z-[1] shadow-sm">
            <tr>
              <th scope="col" className="px-4 py-3 font-semibold">Сумма иска</th>
              <th scope="col" className="px-4 py-3 font-semibold">Размер госпошлины</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-200 dark:divide-gray-700">
            {feeSchedule.map((item, index) => (
              <tr
                key={index}
                className={`hover:bg-gray-50 dark:hover:bg-gray-700/50 transition-colors duration-100
                  ${index === currentRange ? 'bg-indigo-50 dark:bg-indigo-900/20' : ''}`}
              >
                <td className="px-4 py-3 whitespace-nowrap">
                  {formatRange(item.min, item.max)}
                </td>
                <td className={`px-4 py-3 font-medium ${index === currentRange ? 'text-indigo-600 dark:text-indigo-400' : ''}`}>
                  {item.fee}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* Дополнительная информация о госпошлине */}
      <div className="mt-4 p-4 bg-gray-50 dark:bg-gray-800/50 rounded-lg border border-gray-200 dark:border-gray-700">
        <h4 className="text-sm font-medium text-gray-900 dark:text-white mb-2">Важная информация о госпошлине:</h4>
        <ul className="text-sm text-gray-600 dark:text-gray-400 list-disc pl-5 space-y-1">
          <li>Госпошлина уплачивается до подачи искового заявления</li>
          <li>При увеличении исковых требований необходимо доплатить недостающую сумму</li>
          <li>При мировом соглашении возврат госпошлины зависит от стадии процесса</li>
          <li>Истцу возвращается 70% госпошлины при отказе от иска до принятия решения</li>
          <li>При отказе в принятии искового заявления госпошлина возвращается полностью</li>
        </ul>
        <div className="mt-4 text-sm text-gray-500 dark:text-gray-400">
          <p><strong>Правовое основание:</strong> Налоговый кодекс РФ, глава 25.3, ст. 333.19 - 333.22</p>
        </div>
      </div>
    </div>
  );
};

export default CourtFeeSchedule;